var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 143,
    viewBox: "0 0 227 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 226,
    height: 141.164,
    rx: 2.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1249 29.0328C53.0815 29.0328 50.1628 30.1404 48.0109 32.1118C45.8589 34.0833 44.6499 36.7571 44.6499 39.5451V43.0492H182.35V39.5451C182.35 36.7571 181.141 34.0833 178.989 32.1118C176.837 30.1404 173.918 29.0328 170.875 29.0328H56.1249ZM182.35 60.5697H44.6499V102.619C44.6499 105.407 45.8589 108.081 48.0109 110.052C50.1628 112.024 53.0815 113.131 56.1249 113.131H170.875C173.918 113.131 176.837 112.024 178.989 110.052C181.141 108.081 182.35 105.407 182.35 102.619V60.5697ZM59.9499 93.8587C59.9499 92.4646 60.5544 91.1277 61.6304 90.142C62.7064 89.1563 64.1657 88.6025 65.6874 88.6025H77.1624C78.6841 88.6025 80.1434 89.1563 81.2194 90.142C82.2954 91.1277 82.8999 92.4646 82.8999 93.8587C82.8999 95.2527 82.2954 96.5896 81.2194 97.5753C80.1434 98.561 78.6841 99.1148 77.1624 99.1148H65.6874C64.1657 99.1148 62.7064 98.561 61.6304 97.5753C60.5544 96.5896 59.9499 95.2527 59.9499 93.8587ZM96.2874 88.6025C94.7657 88.6025 93.3064 89.1563 92.2304 90.142C91.1544 91.1277 90.5499 92.4646 90.5499 93.8587C90.5499 95.2527 91.1544 96.5896 92.2304 97.5753C93.3064 98.561 94.7657 99.1148 96.2874 99.1148H123.062C124.584 99.1148 126.043 98.561 127.119 97.5753C128.195 96.5896 128.8 95.2527 128.8 93.8587C128.8 92.4646 128.195 91.1277 127.119 90.142C126.043 89.1563 124.584 88.6025 123.062 88.6025H96.2874Z",
    fill: "#CBD5E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 226,
    height: 141.164,
    rx: 2.5,
    stroke: "#E2E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/Generic.50356c7ef59251dc7e910764d4d11260.svg";
export { ForwardRef as ReactComponent };